import React, { Component } from 'react';
import axios from 'axios';
import OpenApp from "react-open-app";
import ToastDownloadApp from './components/ToastDownloadApp.js';
import { Helmet } from 'react-helmet';
import { Base64 } from 'js-base64';
import { detectApp } from '../../common/utils.js';
import ErrorImg from "../../assets/images/404.png";
import ReactLoading from "react-loading";
import { getThemeColor } from '../../common/utils';

export default class LiveroomPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      recording: null,
      uid: this.props.match.params.liveroomId,
      app: null,
      deeplink: null,
      nameLiveroom: null,
      thumbnail: null,
      isLoading: true
    };

    this.getDeeplinkLiveroom = this.getDeeplinkLiveroom.bind(this);
    this.getLiveroomInfo = this.getLiveroomInfo.bind(this);
    this.newGetKey = this.newGetKey.bind(this);
    this.getDeeplinkLiveroom();
  }

  componentDidMount() {
    this.getLiveroomInfo();
  }

  getDeeplinkLiveroom() {
    let json = {
      uid: this.state.uid,
      domain: window.location.hostname,
      type: "LIVEROOM",
      app: "YOKARA"
    }

    const jsonBase64 = Base64.encode(JSON.stringify(json));
    var pass = this.newGetKey(jsonBase64, 7123358024, 3564);
    var keys = jsonBase64 + "-" + pass;

    var url = "/GetDeepLinkFromParam?parameters="+keys;
      axios.post(url, json, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        const deeplink = res.data;
        console.log(res.data);
        // window.location.href = deeplink;
        this.setState({ deeplink }); 
      }, err => {
        console.log("err get deeplink:");
        console.log(err);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.deeplink && this.state.deeplink !== prevState.deeplink) {
      window.location.href = this.state.deeplink;
    }
  }

  getLiveroomInfo() {
    const json = {
      cursor: null,
      language: this.state.language,
      platform: "IOS",
      query: this.state.uid
    }
    const jsonBase64 = Base64.encode(JSON.stringify(json));
    var pass = this.newGetKey(jsonBase64, 7123358024, 3564);
    var keys = jsonBase64 + "-" + pass;

    var url = "/v35.SearchLiveRooms?parameters="+keys;
      axios.post(url, json, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        this.setState({
            nameLiveroom: res.data.rooms[0].name,
            thumbnail: res.data.rooms[0].thumbnail,
            isLoading: false
        });
      }, err => {
          console.log("err:");
          console.log(err);
          this.setState({
            error: 'Không thể tải thông tin phòng',
            isLoading: false
          });
      });
  }
  newGetKey(data, password, password2) {
    var listOfNumbers = "" + password2;
    for (var i = 0 ; i < data.length; i++) {
        if (data.charAt(i) >= '0' && data.charAt(i) <= '9'){
            listOfNumbers = [listOfNumbers.slice(0, 0), data.charAt(i), listOfNumbers.slice(0)].join('');
        }
    }
    var originalKey = null;
  if (listOfNumbers.length > 15) 
    originalKey = listOfNumbers.substring(0,15);
  else
    originalKey = listOfNumbers;
  return Number(originalKey) + Number(password);
}

  render() {
    const { error, recording, deeplink, uid, nameLiveroom, thumbnail, isLoading} = this.state;
    const { t } = this.props;
    if (isLoading) {
      return (
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '60vh'}}>
          <ReactLoading type="bubbles" color={getThemeColor()} height={120} width={60} />
        </div>
      );
    }

    if (error != null) {
      return (
        <div id="content">
          <div className="page-error">
            <div className="container text-center">
              <img src={require('../../assets/images/404.png').default} />
              <h2 className="heading">{t("liveroom_page.error", "Lỗi phòng hát")}</h2>
              <p>{t("liveroom_page.invalid_path", "Đường dẫn không hợp lệ hoặc phòng không tồn tại")}</p>
              <a href="/" className="btn-yellow">
                <i className="fa fa-angle-left" /> {t("liveroom_page.back_home", "Quay về trang chủ")}
              </a>
            </div>
          </div>
        </div>
      )
    } else {
      if (!nameLiveroom) {
        return (
          <div id="content">
            <div className="page-error">
              <div className="container text-center">
                <img src={require('../../assets/images/404.png').default} />
                <h2 className="heading">{t("liveroom_page.error", "Lỗi phòng hát")}</h2>
                <p>{t("liveroom_page.invalid_path", "Đường dẫn không hợp lệ hoặc phòng không tồn tại")}</p>
                <a href="/" className="btn-yellow">
                  <i className="fa fa-angle-left" /> {t("liveroom_page.back_home", "Quay về trang chủ")}
                </a>
              </div>
            </div>
          </div>
        );
      }
      return (
        <>
          <div id="content">
            <Helmet>
              <title>{recording != null && recording.song.songName}</title>
            </Helmet>
            <div className="record-detail-page">
              <div className="container">
                {!detectApp("mi") && (
                  <ToastDownloadApp></ToastDownloadApp>
                )}
                <div className="row">
                  <div className="col-md-8">
                    <div className="item-record pl-xl-4 containerOpenApp"
                      playsInline={true}>
                      {thumbnail != null ? 
                        (<img src={thumbnail} style={{width: '100%', height: 'auto'}}></img>)
                         : (<img src="https://www.yokara.com/react-source/static/media/social_icon_yokara.fcb9e0c2.jpg" style={{width: '100%', height: 'auto'}}></img>)
                      }
                        {deeplink != null ? (
                          <OpenApp href={deeplink}>
                            <button className='btnOpenApp'>Mở Ứng Dụng</button>
                          </OpenApp>
                        ) : (<span>Vui lòng đợi...</span>)}
                    </div><br/>
                    <div className="info-record pl-xl-4">
                      <div className="middle" style={{color:'chocolate'}}>
                        Mời bạn Mở Ứng Dụng để cùng vào hát Kara!<br/>
                        Tên phòng: {nameLiveroom}<br/>
                        ID phòng: {uid}<br/>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}